import { PixelEditor } from './app.js';

document.addEventListener('DOMContentLoaded', () => {
  new PixelEditor();
}); 